import { Link } from "react-router-dom";

export default function SocialCauseBanner() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=happy%20rescued%20dogs%20playing%20together%20in%20sunny%20garden%2C%20joyful%20puppies%2C%20warm%20golden%20light%2C%20green%20grass%2C%20heartwarming%20scene%2C%20professional%20photography%2C%20colorful%20and%20vibrant%2C%20adoption%20cause&width=1200&height=500&seq=causebanner&orientation=landscape"
            alt="San7as Huellitas"
            className="w-full h-[400px] md:h-[500px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#00b4c8]/90 via-[#00b4c8]/60 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-lg px-8 md:px-16">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-heart-fill text-[#fde68a] text-xl"></i>
                <span className="text-[#fde68a] text-xs font-semibold uppercase tracking-widest">
                  Causa Social
                </span>
              </div>
              <h2
                className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4"
              >
                Fundación San7as Huellitas
              </h2>
              <p className="text-white/85 text-base leading-relaxed mb-8">
                Cada compra que realizas contribuye al rescate y adopción de perritos.
              </p>
              <Link
                to="/causas"
                className="inline-flex items-center gap-2 bg-white text-[#00b4c8] font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#e0f7fa] transition-colors cursor-pointer whitespace-nowrap"
              >
                Conocer la Fundación <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
